<script setup lang="ts">
    import { computed } from 'vue';
    import { formatNumericText } from '@shared/utils/formatNumericText';
    import type { Question } from '../../SurveysTypes.d';

    const props = defineProps<{
        question: Question;
        answeredOptionIds: Set<string>;
    }>();

    const sortedOptions = computed(() => [...props.question.QuestionOptions].sort((a, b) => a.Ordinal - b.Ordinal));
</script>

<template>
    <ul class="list-unstyled d-flex flex-wrap gap-sm">
        <li
            class="question-rating d-flex flex-direction-col gap-xs text-center"
            v-for="option in sortedOptions"
            :key="option.QuestionOptionId"
            :class="{ checked: answeredOptionIds.has(option.QuestionOptionId) }">
            <i class="glyphicon" :class="question.OptionsIcon" aria-hidden="true"></i>
            <span>
                {{ option.Value }}
                <template v-if="option.NumericValue != null && option.NumericValue.toString() !== option.Value">
                    ({{ formatNumericText(option.NumericValue) }})
                </template>
            </span>
        </li>
    </ul>
</template>

<style lang="less">
    .question-rating .glyphicon {
        font-size: 28px;
        color: #ccc;
    }

    .question-rating.checked .glyphicon,
    .question-rating:has(~ .question-rating.checked) .glyphicon {
        color: var(--brand-primary-500);
    }
</style>
